export { API_ND_AREA } from '../constants';
export const CRUMB_LABEL_KEY = 'edtDealer';
export const NAME = 'Dealer';
